// Tenant brand logos (served from public/logos), keyed by tenant subdomain.
// The backend has no logo field yet, so logos are registered here. Each image
// includes the clinic name, so it replaces both the app icon and the text.
const TENANT_LOGOS = {
  manoj: '/logos/manoj-ayurveda.png',
};

export const getTenantLogo = (subdomain) => (subdomain ? TENANT_LOGOS[subdomain] || null : null);
